import { Auth0Provider } from '@auth0/auth0-react';
import { useAtom } from 'jotai';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { Outlet, useLocation } from 'react-router-dom';

import { Splash } from '@/components';
import useToast from '@/hooks/useToast';
import { Login } from '@/modules/auth/Login';
import { fetchAuth0Config } from '@/services';
import { rememberClient } from '@/services/editProfile_pwdReset';
import { recessPosterAtom } from '@/store';

const Root = () => {
  const toast = useToast();
  const location = useLocation();

  const parsed = queryString.parse(location.search);

  const [, setRecessPoster] = useAtom(recessPosterAtom);
  const { data, isLoading } = useQuery(
    'auth0Config',
    async () => await fetchAuth0Config(),
    {
      staleTime: 1000 * 60 * 5, // 5 minutos
      cacheTime: 1000 * 60 * 10, // 10 minutos
      refetchOnWindowFocus: false,
      onError: (err) => {
        const error = err as Error;
        toast.show(error.message);
      },
      onSuccess(data) {
        if (data && data.estado === false) {
          toast.show(data.mensaje);
        }
      },
    }
  );
  useEffect(() => {
    if (data && data.estado) {
      setRecessPoster({ ...data, hayPlaca: data.hayPlaca });
      rememberClient({ clientId: data.clientId, domain: data?.domain });
    }
  }, [data, setRecessPoster]);

  useEffect(() => {
    if (parsed?.tkRed) {
      sessionStorage.setItem('tkRed', JSON.stringify(parsed.tkRed));
    }
    const tkRedAndroid = Cookies.get('android_tkRed');
    if (tkRedAndroid) {
      sessionStorage.setItem('tkRed', JSON.stringify(tkRedAndroid));
      Cookies.remove('android_tkRed');
    }
  }, [parsed.tkRed]);

  if (!data && isLoading) {
    return <Splash />;
  }

  if (data && data.estado) {
    return (
      <Auth0Provider
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: data.apiAudience || undefined, // apiAudience
        }}
        cacheLocation="localstorage"
        clientId={data.clientId}
        domain={data.domain}
        useRefreshTokens={false}
      >
        <Outlet />
      </Auth0Provider>
    );
  }

  return <Login />;
};

export default Root;
